import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"project-select","item-text":"nome","item-name":"projetoId","item-value":"projetoId","items":_vm.projects,"label":"Projeto","placeholder":"Projeto","solo":"","hide-details":"auto","disabled":_vm.disabled,"clearable":""},on:{"change":(e) => {
      _vm.$emit('changeProject', _vm.filter.projetoId);
      _vm.$emit(
        'nameChange',
        this.projects
          .filter((val) => val.projetoId == _vm.filter.projetoId)
          .map((item) => item.nome)
      );
    }},model:{value:(_vm.filter.projetoId),callback:function ($$v) {_vm.$set(_vm.filter, "projetoId", $$v)},expression:"filter.projetoId"}},[_c('template',{slot:"no-data"},[_vm._v(" Nenhum Projeto retornado ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }